var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.satisfied === false,
          expression: "satisfied === false",
        },
      ],
    },
    _vm._l(_vm.errors, function (error, index) {
      return _c(
        "el-alert",
        {
          key: index,
          staticStyle: { margin: "20px 0" },
          attrs: { title: _vm.title, type: "info", "show-icon": "" },
        },
        [
          _c(
            "ul",
            { staticClass: "shipping-eligibility-message-list" },
            _vm._l(_vm.blacklist, function (item) {
              return _c("li", { key: item }, [
                _vm._v("\n        " + _vm._s(item) + "\n      "),
              ])
            }),
            0
          ),
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }